import {
  Component,
  inject,
  CUSTOM_ELEMENTS_SCHEMA,
  ChangeDetectionStrategy,
  output,
} from '@angular/core';
import { CommonModule } from '@angular/common';

import { TidyUiComponentsModule } from 'src/tidy-ui-components/tidy-ui-components.module';
import { DemoBlockService } from 'src/shared/services/demo-block.service';

@Component({
  selector: 'sensor-promo-card',
  templateUrl: './sensor-promo-card.component.html',
  standalone: true,
  imports: [CommonModule, TidyUiComponentsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SensorPromoCardComponent {
  private readonly demoBlock = inject(DemoBlockService);

  readonly orderClick = output<void>();
  readonly learnMoreClick = output<void>();

  onOrderClick(): void {
    if (this.demoBlock.block()) { return; }
    this.orderClick.emit();
  }
}
